import { get, isArray } from 'lodash';

export const anonymousPerson = {
  avatarUrl: null,
  email: null,
  fullName: null,
  id: null,
  isDeleted: false,
  isSegmentAllowed: false,
  name: 'Анонимный',
  isPartnerClient: false,
  phone: null,
  surname: 'клиент',
  type: null,
  messengers: null,
};

export const serializePerson = person => {
  if (!person) return null;

  const {
    id,
    name,
    surname,
    full_name: fullName,
    is_segment_allowed: isSegmentAllowed,
  } = person;

  return {
    id: String(id),
    email: get(person, 'email') || '',
    avatarUrl:
      person.avatar_url !== 'client_auth/default_avatar@2x.jpg'
        ? person.avatar_url
        : null, // TODO: Fix on backend
    name,
    surname,
    fullName,
    phone: get(person, 'phone') || get(person, 'sip_extension') || null,
    isSegmentAllowed,
    description: person.description,
    type: person.person_type,
    skillGroupId: person.skill_group_id,
    labelIds: person.label_ids || [],
  };
};

export const serializePersonsToMap = persons => {
  if (!isArray(persons) || persons.length < 1) return null;

  return persons.reduce(
    (acc, pr) =>
      pr && pr.id
        ? {
            [pr.id.toString()]: serializePerson(pr),
            ...acc,
          }
        : acc,
    {}
  );
};

export const serializePersons = persons => {
  if (!isArray(persons) || persons.length < 1) return null;

  return persons.map(person => serializePerson(person));
};
